import Centrifuge from 'centrifuge';

import {
  AUTOPAYROLL_EVENTS,
  MESSAGING_V2_EVENTS,
  OTHER_EVENTS,
  PRODUCTION,
} from 'features/messengerv2/constants';
import { TRAINING_EVENTS } from 'features/training/constants';

class CentrifugeAdapter {
  constructor({
    onAddNewMessage,
    onUpdateMessage,
    onUpdateChannel,
    onUpdateChannelWithIndex,
    onSetUnreadMessages,
    onDeleteChannel,
    onApplicantReceiveNewMessage,
    onUpdateLeftNavigation,
    onShowFiveMinuteWarningModal,
    wssConfig,
  }) {
    /** MessengerV2 actions */
    this.onAddNewMessage = onAddNewMessage;
    this.onUpdateMessage = onUpdateMessage;
    this.onUpdateChannel = onUpdateChannel;
    this.onUpdateChannelWithIndex = onUpdateChannelWithIndex;
    this.onSetUnreadMessages = onSetUnreadMessages;
    this.onDeleteChannel = onDeleteChannel;
    /** Other actions */
    this.onApplicantReceiveNewMessage = onApplicantReceiveNewMessage;
    this.onUpdateLeftNavigation = onUpdateLeftNavigation;
    this.onShowFiveMinuteWarningModal = onShowFiveMinuteWarningModal;
    /** Config */
    this.config = wssConfig;
    this.debug = window.Homebase.env !== PRODUCTION;

    this.initDispatcher();
  }

  // eslint-disable-next-line no-console
  log = console.log;

  handleEvents = ({ event, data }) => {
    switch (event) {
      case MESSAGING_V2_EVENTS.MESSAGE_CREATED:
        if (!data.is_mine) this.onAddNewMessage(data);
        break;
      case MESSAGING_V2_EVENTS.MESSAGE_UPDATED:
        this.onUpdateMessage(data);
        break;
      case MESSAGING_V2_EVENTS.CHANNEL_UPDATED:
        this.onUpdateChannel(data);
        break;
      case MESSAGING_V2_EVENTS.CHANNEL_UPDATED_WITH_INDEX:
        this.onUpdateChannelWithIndex(data);
        break;
      case MESSAGING_V2_EVENTS.UNREAD_COUNT_UPDATED:
        this.onSetUnreadMessages(data.count);
        break;
      case MESSAGING_V2_EVENTS.CHANNEL_DELETED:
        this.onDeleteChannel(data);
        break;
      case OTHER_EVENTS.HIRING_NEW_MESSAGE:
        this.onApplicantReceiveNewMessage(data);
        break;
      case OTHER_EVENTS.CURRENT_LOCATION_CHANGED:
        window.location.reload();
        break;
      case OTHER_EVENTS.LEFT_NAV_CHANGED:
        this.onUpdateLeftNavigation(data);
        break;
      case AUTOPAYROLL_EVENTS.AUTOPAYROLL_FIVE_MINUTE_WARNING:
        this.onShowFiveMinuteWarningModal();
        break;
      case AUTOPAYROLL_EVENTS.AUTOPAYROLL_SUBMITTED_REFRESH:
        window.location.href = '/payroll';
        break;
      case TRAINING_EVENTS.TRAINING_UPDATED:
        window.dispatchEvent(
          new CustomEvent('training_updated', { detail: data })
        );
        break;
      default:
    }

    if (this.debug) this.log(`Received WSS event`, event, data);
  };

  initDispatcher = () => {
    if (window.testEnv) return;

    if (this.debug) {
      this.log(this.config.toJSON());

      if (this.config.isEmpty()) {
        this.log('give up on a ws connection due to the wss config is empty');
        return;
      }
    }

    const path = `${this.config.get('endpoint')}/connection/websocket`;
    const channelUser = this.config.get('channel_user');
    const channelCompany = this.config.get('channel_company');
    const dispatcher = new Centrifuge(path, { debug: this.debug });
    dispatcher.setToken(this.config.get('token'));
    dispatcher.connect();

    if (channelUser) {
      dispatcher.subscribe(channelUser, message => {
        if (this.debug) {
          this.log('[WS][user] raw message', message);
        }

        this.handleEvents(message.data);
      });
    }

    if (channelCompany) {
      dispatcher.subscribe(channelCompany, message => {
        if (this.debug) {
          this.log('[WS][company] raw message', message);
        }

        this.handleEvents(message.data);
      });
    }

    window.websocket = dispatcher;
  };
}

export const createCentrifugeAdapter = params => new CentrifugeAdapter(params);
